import type { ZoneLayout } from '../../zones/types';
import { buildColossusCinderhide, buildColossusDunestrider, buildColossusGloomfang, buildColossusRimebound } from './colossus';
import { buildCrucible } from './crucible';
import { buildCrypt } from './crypt';
import { buildDeepvault1, buildDeepvault2 } from './deepvault';
import { buildGlimmer } from './glimmer';
import { buildHaven } from './haven';
import { buildKeep } from './keep';
import { buildRift1, buildRift2, buildRift3 } from './rift';
import { buildSea } from './sea';
import { buildSiege1, buildSiege2, buildSiege3 } from './siege';
import { buildTomb } from './tomb';

/**
 * Instanced maps (story dungeons, Rift Delve floors, Colossus arenas,
 * Deepvault and Warlord Siege gates, the Crucible) plus the sailing sea and
 * its islands, by zone id. Builders are deterministic, so every peer builds
 * the same layout locally.
 */
export const INSTANCE_ZONES: Record<string, () => ZoneLayout> = {
  crypt: buildCrypt,
  tomb: buildTomb,
  keep: buildKeep,
  rift_1: buildRift1,
  rift_2: buildRift2,
  rift_3: buildRift3,
  colossus_cinderhide: buildColossusCinderhide,
  colossus_gloomfang: buildColossusGloomfang,
  colossus_rimebound: buildColossusRimebound,
  colossus_dunestrider: buildColossusDunestrider,
  deepvault_1: buildDeepvault1,
  deepvault_2: buildDeepvault2,
  siege_1: buildSiege1,
  siege_2: buildSiege2,
  siege_3: buildSiege3,
  crucible: buildCrucible,
  haven: buildHaven,
  glimmer: buildGlimmer,
  sea: buildSea,
};
